import { guidFor } from '@ember/object/internals';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import HotelChannelPricingTablesCellsPmsTablePricesPmsTablePricingRowCellContent from 'lumen/components/hotel/channel-pricing/tables/cells/pms-table/prices/pms-table-pricing-row-cell-content';
import HotelChannelPricingTablesCellsPmsTableRestrictionsPmsTableRestrictionsRowCellContent from 'lumen/components/hotel/channel-pricing/tables/cells/pms-table/restrictions/pms-table-restrictions-row-cell-content';
import type {
  TdPmsTablePeriodColumnSignature,
  TdPmsTableRowSignature,
} from 'lumen/components/hotel/channel-pricing/tables/pms-table';
import trackColumnHover from 'lumen/modifiers/channel-pricing/track-column-hover';
import { PMS_TABLE_ROW_TYPES } from 'lumen/utils/constants/channel-pricing-constants';

import styles from './td-pms-table-value-cell.module.css';

interface HotelChannelPricingTablesCellsPmsTableTdPmsTableValueCellSignature {
  Args: {
    column: TdPmsTablePeriodColumnSignature;
    row: TdPmsTableRowSignature;
  };
}

export default class HotelChannelPricingTablesCellsPmsTableTdPmsTableValueCell extends Component<HotelChannelPricingTablesCellsPmsTableTdPmsTableValueCellSignature> {
  @service('channel-pricing/table-hover')
  declare channelPricingTableHover: Services['channel-pricing/table-hover'];

  cellId = `pms-table-value-cell-${guidFor(this)}`;

  get isCellOfHoveredColumn(): boolean {
    if (
      this.channelPricingTableHover.hoveredColumnId !== null &&
      this.channelPricingTableHover.hoveredColumnId === this.args.column.id
    ) {
      return true;
    }

    return false;
  }

  get isPricingChildRow(): boolean {
    return this.args.row.type === PMS_TABLE_ROW_TYPES.PRICING_CHILD_ROW;
  }

  get isPricingParentRow(): boolean {
    return this.args.row.type === PMS_TABLE_ROW_TYPES.PRICING_PARENT_ROW;
  }

  get isPricingRow(): boolean {
    return this.isPricingParentRow || this.isPricingChildRow;
  }

  get isRestrictionsRow(): boolean {
    return this.args.row.type === PMS_TABLE_ROW_TYPES.RESTRICTION;
  }

  <template>
    <div
      {{! relative is needed to render the CTA in the cell }}
      class="relative flex h-full items-center justify-end
        {{styles.value-cell}}
        {{if this.isCellOfHoveredColumn styles.highlighted}}
        {{if @column.isPastDay styles.is-past}}"
      {{trackColumnHover @column.id}}
      data-test-id="td-pms-table-value-cell"
    >
      {{! SMART DISTRIBUTION Watch out: There is a popover in these child components pointing to this <div id=this.cellId }}
      {{! Changes in this structure: it will break the popover behavior }}
      {{#if this.isRestrictionsRow}}
        <HotelChannelPricingTablesCellsPmsTableRestrictionsPmsTableRestrictionsRowCellContent
          @column={{@column}}
          @parentCellId={{this.cellId}}
          @row={{@row}}
        />
      {{else if this.isPricingRow}}
        <HotelChannelPricingTablesCellsPmsTablePricesPmsTablePricingRowCellContent
          @column={{@column}}
          @isPricingChildRow={{this.isPricingChildRow}}
          @parentCellId={{this.cellId}}
          @row={{@row}}
        />
      {{/if}}
    </div>
  </template>
}
